import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/ContactPage.css';
var ga = window.ga;

class ContactPage extends Component {
	constructor(props) {
		super(props);

	}

  componentDidMount() {
    ga('send', 'event', 'Contact Page', 'Page View');
  }


  render() {
    return (
      <div id="ContactPage" ref={(el) => this.el = el}>
      	<h1>say hi, we're friendly!</h1>
        <h2><a href="mailto:hello@savage.ly">hello@savage.ly</a></h2>
        <h2>323-696-7807</h2>
        <h2>
          4470 W Sunset Blvd #90092<br/>
          Los Angeles CA, 90027
        </h2>


      </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/scripts/containers/ContactPage.js